/**
 * @module components\ghTable\dataTable\dataRow\dataCell\textCell
 */
import Vue from "vue";
import Component from "vue-class-component";
import DataCellBase from "../dataCellBase";

@Component
export default class TextCell extends DataCellBase {
  created() {
    
  }
}
